import { render } from "./HelixOptions.vue?vue&type=template&id=39631fd2&scoped=true"
import script from "./HelixOptions.vue?vue&type=script&lang=js"
export * from "./HelixOptions.vue?vue&type=script&lang=js"

import "./HelixOptions.vue?vue&type=style&index=0&id=39631fd2&scoped=true&lang=css"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39631fd2"]])

export default __exports__